export default {
    data () {
        return {
            courierList: [
                {
                    id: 0,
                    label: 'UNKNOWN',
                    styleTag: {
                        color: 'rgba(0, 0, 0,1)',
                        backgroundColor: 'rgba(0, 0, 0,.1)',
                        borderColor: 'rgba(0, 0, 0,.2)'
                    }
                },
                {
                    id: 1,
                    label: 'SCG',
                    styleTag: {
                        color: 'rgba(245, 107, 107,1)',
                        backgroundColor: 'rgba(245, 107, 107,.1)',
                        borderColor: 'rgba(245, 107, 107,.2)'
                    }
                },
                {
                    id: 2,
                    label: 'KERRY',
                    styleTag: {
                        color: 'rgba(244, 111, 34,1)',
                        backgroundColor: 'rgba(244, 111, 34,.1)',
                        borderColor: 'rgba(244, 111, 34,.2)'
                    }
                },
                {
                    id: 3,
                    label: 'DHL',
                    styleTag: {
                        color: 'rgba(249, 192, 63,1)',
                        backgroundColor: 'rgba(249, 192, 63,.1)',
                        borderColor: 'rgba(249, 192, 63,.2)'
                    }
                },
                {
                    id: 4,
                    label: 'FLASH',
                    styleTag: {
                        color: 'rgba(249, 192, 63,1)',
                        backgroundColor: 'rgba(249, 192, 63,.1)',
                        borderColor: 'rgba(249, 192, 63,.2)'
                    }
                },
                {
                    id: 5,
                    label: 'CJ',
                    styleTag: {
                        color: 'rgba(0, 0, 0,1)',
                        backgroundColor: 'rgba(0, 0, 0,.1)',
                        borderColor: 'rgba(0, 0, 0,.2)'
                    }
                },
                {
                    id: 6,
                    label: 'THAI POST',
                    styleTag: {
                        color: 'rgba(46, 49, 146,1)',
                        backgroundColor: 'rgba(46, 49, 146,.1)',
                        borderColor: 'rgba(46, 49, 146,.2)'
                    }
                },
                {
                    id: 7,
                    label: 'DLT',
                    styleTag: {
                        color: 'rgba(0,0,0,1)',
                        backgroundColor: 'rgba(0,0,0,.1)',
                        borderColor: 'rgba(0,0,0,.2)'
                    }
                },
                {
                    id: 8,
                    label: 'OTHER',
                    styleTag: {
                        color: 'rgba(0,0,0,1)',
                        backgroundColor: 'rgba(255, 0, 0, 0.2)',
                        borderColor: 'rgba(0,0,0,.2)'
                    }
                },
                {
                    id: 9,
                    label: 'BEST',
                    styleTag: {
                        color: 'rgba(255, 0, 0, 1)',
                        backgroundColor: 'rgba(255, 0, 0, 0.2)',
                        borderColor: 'rgba(224, 163, 163, 1)'
                    }
                },
                {
                    id: 10,
                    label: 'BEE',
                    styleTag: {
                        color: 'rgba(249, 192, 63,1)',
                        backgroundColor: 'rgba(249, 192, 63,.1)',
                        borderColor: 'rgba(249, 192, 63,.2)'
                    }
                },
                {
                    id: 11,
                    label: 'J&T',
                    styleTag: {
                        color: 'rgb(247, 0, 2, 1)',
                        backgroundColor: 'rgb(247, 0, 1, 0.1)',
                        borderColor: 'rgb(247, 0, 2, 1)'
                    }
                },
                {
                    id: 12,
                    label: 'NIM EXPRESS',
                    styleTag: {
                        color: 'rgb(255, 153, 0, 1)',
                        backgroundColor: 'rgb(255, 153, 1, 0.1)',
                        borderColor: 'rgb(255, 153, 0, 1)'
                    }
                },
                {
                    id: 13,
                    label: 'ALPHA',
                    styleTag: {
                        color: 'rgb(207, 0, 2, 1)',
                        backgroundColor: 'rgb(207, 0, 1, 0.1)',
                        borderColor: 'rgb(207, 0, 2, 1)'
                    }
                },
                {
                    id: 14,
                    label: 'LINE MAN',
                    styleTag: {
                        color: 'rgb(51, 204, 51, 1)',
                        backgroundColor: 'rgb(51, 204, 50, 0.1)',
                        borderColor: 'rgb(51, 204, 51, 1)'
                    }
                },
                {
                    id: 15,
                    label: 'LALAMOVE',
                    styleTag: {
                        color: 'rgb(51, 204, 255, 1)',
                        backgroundColor: 'rgb(51, 204, 254, 0.1)',
                        borderColor: 'rgb(51, 204, 255, 1)'
                    }
                },
                {
                    id: 16,
                    label: 'NINJAVAN',
                    styleTag: {
                        color: 'rgb(0, 51, 204, 1)',
                        backgroundColor: 'rgb(0, 51, 204, 0.1)',
                        borderColor: 'rgb(0, 51, 204, 1)'
                    }
                },
                {
                    id: 17,
                    label: 'CJ LOGISTIC',
                    styleTag: {
                        color: 'rgb(233, 232, 1, 1)',
                        backgroundColor: 'rgb(233, 232, 1, 0.1)',
                        borderColor: 'rgb(233, 232, 1, 1)'
                    }
                },
                {
                    id: 18,
                    label: 'SKOOTAR',
                    styleTag: {
                        color: 'rgb(153, 204, 255, 1)',
                        backgroundColor: 'rgb(153, 204, 255, 0.1)',
                        borderColor: 'rgb(153, 204, 255, 1)'
                    }
                },
                {
                    id: 19,
                    label: 'SHOPEE EXPRESS',
                    styleTag: {
                        color: 'rgb(238, 77, 45)',
                        backgroundColor: 'rgb(255, 255, 255,255)',
                        borderColor: 'rgb(255, 255, 255,255)'
                    }
                }
            ],
            paymentTypeList: [
                { id: 0, th: 'UNKNOWN', en: 'UNKNOWN', label: 'UNKNOWN' },
                { id: 1, th: 'รอชำระเงิน', en: 'waiting', label: 'WAITING' },
                { id: 2, th: 'เก็บเงินปลายทาง', en: 'cod', label: 'COD' },
                { id: 3, th: 'โอนเงิน', en: 'transfer', label: 'TRANSFER' },
                { id: 4, th: 'เคลมสินค้า', en: 'claim', label: 'CLAIM' }
            ],
            purchaseChannelList: [
                { id: 0, label: 'UNKNOWN' },
                { id: 1, label: 'FACEBOOK' },
                { id: 2, label: 'MESSENGER' },
                { id: 3, label: 'LINE' },
                { id: 4, label: 'CALL' },
                { id: 5, label: 'INSTAGRAM' },
                { id: 6, label: 'WWW' },
                { id: 7, label: 'OTHER' },
                { id: 8, label: 'SHOPEE' }
            ],
            orderStatusList: [
                // Pending
                { id: 1, en: 'Pending', th: 'รอดำเนินการ' },
                // Prepare to Ship
                { id: 2, en: 'Prepare to Ship', th: 'เตรียมตัวส่ง' },
                // Ready to Ship
                { id: 3, en: 'Ready to Ship', th: 'พร้อมจัดส่ง' },
                // In Transit
                { id: 4, en: 'Shipped', th: 'ขนส่งรับสินค้าเข้าคลังแล้ว' },
                { id: 5, en: 'Out for delivery', th: 'พัสดุกำลังนำส่ง' },
                { id: 6, en: 'Failed to delivery', th: 'ส่งไม่สำเร็จ' },
                // Completed
                { id: 7, en: 'Return', th: 'ถูกตีกลับ' },
                { id: 8, en: 'Delivered', th: 'ส่งสำเร็จแล้ว' },
                { id: 9, en: 'COD Remited', th: 'เงินเข้าระบบแล้ว' },
                // Unknown
                { id: 10, en: 'Unknown', th: 'ไม่สามารถระบุสถานะได้' },
                { id: 11, en: 'Return_Delivered_CODRemited', th: 'ถูกตีกลับ_ส่งสำเร็จแล้ว_เงินเข้าระบบแล้ว' },
                { id: 13, en: 'Delivered_CODRemited', th: 'ส่งสำเร็จแล้ว_เงินเข้าระบบแล้ว' }
            ],
            printKeyword: ['print', 'noprint'],
            bankTypelist: [
                { id: 1, logoPath: require('@/assets/bank/k-bank46x46.jpg'), label: 'ธนาคารกสิกรไทย' },
                { id: 2, logoPath: require('@/assets/bank/scb-bank46x46.jpg'), label: 'ธนาคารไทยพาณิชย์' },
                { id: 3, logoPath: require('@/assets/bank/bangkok-bank46x46.jpg'), label: 'ธนาคารกรุงเทพ' },
                { id: 4, logoPath: require('@/assets/bank/ktb-bank46x46.jpg'), label: 'ธนาคารกรุงไทย' },
                { id: 5, logoPath: require('@/assets/bank/tmb-bank46x46.jpg'), label: 'ธนาคารทหารไทย' },
                { id: 6, logoPath: require('@/assets/bank/krungsri-bank46x46.jpg'), label: 'ธนาคารกรุงศรีอยุธยา' },
                { id: 7, logoPath: require('@/assets/bank/gsb-bank46x46.jpg'), label: 'ธนาคารออมสิน' },
                { id: 8, logoPath: require('@/assets/bank/other.png'), label: 'ธนาคารอื่นๆ' },
                { id: 9, logoPath: require('@/assets/bank/thanachart-bank.png'), label: 'ธนาคารธนชาต' },
                { id: 10, logoPath: require('@/assets/bank/tisco-bank.png'), label: 'ธนาคารทิสโก้' },
                { id: 11, logoPath: require('@/assets/bank/uob-bank.png'), label: 'ธนาคารยูโอบี' },
                { id: 12, logoPath: require('@/assets/bank/kiatnakin-bank.png'), label: 'ธนาคารเกียรตินาคิน' },
                { id: 13, logoPath: require('@/assets/bank/cimb_bank.png'), label: 'ธนาคารซีไอเอ็มบีไทย' },
                { id: 14, logoPath: require('@/assets/bank/lh_bank.png'), label: 'ธนาคารแลนด์ แอนด์ เฮาส์' }
            ],
            LogCreateChipmentErrMsg: [
                { id: 1, code: '0501', th: 'ไม่มีข้อมูลในระบบ' },
                { id: 2, code: '0502', th: 'เลข Tracking ผิดพลาด' },
                { id: 3, code: '0503', th: 'เลข Tracking ถูกใช้ไปแล้ว' },
                { id: 4, code: '0510', th: 'Shipper sub_district is not available' },
                { id: 5, code: '0507', th: 'API FLASH Error !' },
                { id: 6, code: '0511', th: 'Shipping tracking_number is invalid.' }
            ],
            ZoneBkk: [
                { id: 1, code: 'THB', province: 'กรุงเทพมหานคร' },
                { id: 2, code: 'THB', province: 'นนทบุรี' },
                { id: 3, code: 'THB', province: 'ปทุมธานี' },
                { id: 4, code: 'THB', province: 'สมุทรสาคร' },
                { id: 5, code: 'THB', province: 'สมุทรปราการ' },
                { id: 6, code: 'THB', province: 'นครปฐม' }
            ],
            QuotationRequesList: [
                { id: 0, label: 'Lead' },
                { id: 1, label: 'Called' }
            ],
            CustomerStatus: [
                { id: 0, label: 'Deactivate' },
                { id: 1, label: 'Activate' },
                { id: 2, label: 'All' }
            ],
            CustomerStatusAccount: [
                { id: 0, label: 'New' },
                { id: 1, label: 'Exist' }
            ],
            ApproveStatusLabel: [
                { id: 6, label: 'รอตรวจสอบ' },
                { id: 7, label: 'ต้องการข้อมูลเพิ่มเติม' },
                // approve_status = 8 means CS already approved document
                // But the full registration process will be checked from is_approve instead
                { id: 8, label: 'รอตรวจสอบ' },
                { id: 9, label: 'รอตรวจสอบ' }
            ],
            SubscriptionStatusLabel: [
                { id: 1, label: 'New' },
                { id: 2, label: 'Active' },
                { id: 3, label: 'Soft Suspended' },
                { id: 4, label: 'Expired' }
            ],
            SubscriptionPaymentStatusLabel: [
                { id: 2, label: 'จ่ายแล้ว' }
            ],

            OrderTypeUtility: [ // Order Manage Type
                { id: 0, label: 'All' },
                { id: 1, label: 'Web' },
                { id: 2, label: 'Mobile' }
            ],
            typeCod: [
                { id: 0, label: 'เปอร์เซ็น' },
                { id: 1, label: 'บาท' }
            ],
            PriceType: [
                { id: 1, label: 'Weight' },
                { id: 2, label: 'Size' }
            ]
        }
    },
    methods: {
        getZone (province) {
            let hasZone = this.ZoneBkk.filter((e) => { return e.province === province })
            if (hasZone.length > 0) {
                return hasZone[0].code
            } else {
                return 'TH1'
            }
        },
        getCourier (courierID) {
            let hasCourier = this.courierList.filter((e) => { return e.id === courierID })
            if (hasCourier.length > 0) {
                return hasCourier[0].label
            } else {
                return courierID
            }
        },
        getCourierObject (courierID) {
            let hasCourier = this.courierList.filter((e) => { return e.id === courierID })
            if (hasCourier.length > 0) {
                return hasCourier[0]
            } else {
                return courierID
            }
        },
        getCourierId (name) {
            // console.log(this.courierList)
            let hasCourier = this.courierList.filter((e) => { return e.label === name })
            if (hasCourier.length > 0) {
                return hasCourier[0].id
            } else {
                return false
            }
        },
        getBank (bankID) {
            let hasBank = this.bankTypelist.filter((e) => { return e.id === bankID })
            if (hasBank.length > 0) {
                return hasBank[0].label
            } else {
                return hasBank
            }
        },
        getPaymentType (paymentType) {
            let hasPayment = this.paymentTypeList.filter((e) => { return e.id === paymentType })
            if (hasPayment.length > 0) {
                return hasPayment[0].th
            } else {
                return paymentType
            }
        },
        getPaymentTypeEn (paymentType) {
            let hasPayment = this.paymentTypeList.filter((e) => { return e.id === paymentType })
            if (hasPayment.length > 0) {
                return hasPayment[0].label
            } else {
                return paymentType
            }
        },
        getPurchaseChannel (purchaseChannel) {
            let hasPC = this.purchaseChannelList.filter((e) => { return e.id === purchaseChannel })
            if (hasPC.length > 0) {
                return hasPC[0].label
            } else {
                return hasPC
            }
        },
        getOrderStatus (orderStatus) {
            // return this.orderStatusList.filter((e) => { return e.id === orderStatus })[0].th
            let hasPC = this.orderStatusList.filter((e) => { return e.id === orderStatus })
            if (hasPC.length > 0) {
                return hasPC[0].th
            } else {
                return hasPC
            }
        },
        getOrderStatusEn (orderStatus) {
            let hasPC = this.orderStatusList.filter((e) => { return e.id === orderStatus })
            if (hasPC.length > 0) {
                return hasPC[0].en
            } else {
                return hasPC
            }
        },
        getPrintKeyword (printStatus) {
            return this.printKeyword[printStatus ? 0 : 1]
        },
        getCreateShipmentErrCode (code) {
            let hasCode = this.LogCreateChipmentErrMsg.filter((e) => { return e.code === code })
            if (hasCode.length > 0) {
                return hasCode[0].th
            } else {
                return hasCode
            }
        },
        GetSCGTrackingNumber (orderNumber, isCod) {
            // console.log(orderNumber, isCod)
            let trackingNumber = ''
            if (isCod) {
                trackingNumber = '111' + orderNumber.toString()
            } else {
                trackingNumber = '121' + orderNumber.toString()
            }
            let trackingLastDigit = parseInt(trackingNumber) - parseInt(Math.floor(parseFloat(trackingNumber) / 7)) * 7
            trackingNumber = trackingNumber + trackingLastDigit.toString()
            return trackingNumber
        },
        formatAddress ({ subDistrict, district, province, zipcode }) {
            if (province === 'กรุงเทพมหานคร') {
                return `แขวง${subDistrict} เขต${district} ${province} ${zipcode}`
            } else {
                return `ต.${subDistrict} อ.${district} จ.${province} ${zipcode}`
            }
        },
        getCustomerStatusAccount (id) {
            let hasCode = this.CustomerStatusAccount.filter((e) => { return e.id === id })
            if (hasCode.length > 0) {
                return hasCode[0].label
            } else {
                return hasCode
            }
        },
        getApproveStatusLabel (approveStatus, isApprove) {
            if (isApprove) {
                return 'ยืนยันตัวตนสำเร็จ'
            }

            let hasCode = this.ApproveStatusLabel.filter((e) => { return e.id === approveStatus })
            if (hasCode.length > 0) {
                return hasCode[0].label
            } else {
                return 'ยังไม่ได้ยืนยันตัวตน'
            }
        },
        getSubscriptionStatusLabel (id) {
            let hasCode = this.SubscriptionStatusLabel.filter((e) => { return e.id === id })
            if (hasCode.length > 0) {
                return hasCode[0].label
            } else {
                return hasCode
            }
        },
        getSubscriptionPaymentStatusLabel (id) {
            let hasCode = this.SubscriptionPaymentStatusLabel.filter((e) => { return e.id === id })
            if (hasCode.length > 0) {
                return hasCode[0].label
            } else {
                return 'ยังไม่จ่ายเงิน'
            }
        },
        getTypeCod (id) {
            let hasCode = this.typeCod.filter((e) => { return e.id === id })
            if (hasCode.length > 0) {
                return hasCode[0].label
            } else {
                return hasCode
            }
        },
        getPriceType (id) {
            let hasCode = this.PriceType.filter((e) => { return e.id === id })
            if (hasCode.length > 0) {
                return hasCode[0].label
            } else {
                return id
            }
        },
        $onCheckCovidZipcodeFlash (index) {
            const textAlert = `เนื่องจากสถานะการณ์การแพร่ระบาด COVID-19 ที่รุนแรง ทาง Flash มีความจำเป็นที่จะของดให้บริการชั่วคราว ในพื้นที่  ตำบล ${this.itemList[index].shippingSubDistrict} อำเภอ ${this.itemList[index].shippingDistrict} จังหวัด ${this.itemList[index].shippingProvince} หากสถานการณ์กลับมาปกติ ทางเราจะทำการเปิดบริการของ Flash อีกครั้ง`
            this.$alert(textAlert, 'แจ้งให้ทราบ!', {
                confirmButtonText: 'OK',
                type: 'warning',
                center: true,
                callback: action => {
                    this.itemList[index].loading = false
                    return false
                }
            })
        }
    }
}
